(function () {
  'use strict';
  if (window.roccoKachingShowMore) return;
  window.roccoKachingShowMore = true;
  var widgets = new WeakMap();
  var lists = new WeakMap();
  var controlLists = new WeakMap();
  var nextId = 0;
  var labels = {
    de: { more: 'Mehr anzeigen', less: 'Weniger anzeigen', selected: 'Ausgewählt: ' },
    it: { more: 'Mostra altro', less: 'Mostra meno', selected: 'Selezionato: ' },
    en: { more: 'Show more', less: 'Show less', selected: 'Selected: ' }
  };

  function ensureStyles() {
    if (document.getElementById('rocco-kaching-show-more-styles')) return;
    var style = document.createElement('style');
    style.id = 'rocco-kaching-show-more-styles';
    style.textContent = [
      '[data-rocco-bundle-overflow-hidden]{display:none!important}',
      '.rocco-kaching-more{margin-top:1rem}',
      '.rocco-kaching-more__button{appearance:none;display:flex;align-items:center;justify-content:center;gap:.7rem;box-sizing:border-box;width:100%;min-height:44px;padding:1rem 1.2rem;border:1px solid rgba(174,183,142,.6);border-radius:8px;background:rgba(174,183,142,.12);color:#121212;font:inherit;font-size:1.4rem;font-weight:500;line-height:1.4;cursor:pointer}',
      '.rocco-kaching-more__button:hover{background:rgba(174,183,142,.25)}',
      '.rocco-kaching-more__button:focus-visible{outline:2px solid #aeb78e;outline-offset:3px}',
      '.rocco-kaching-more__button svg{flex:0 0 16px;width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}',
      '.rocco-kaching-more__button[aria-expanded="true"] svg{transform:rotate(180deg)}',
      '.rocco-kaching-more__selection{margin:.7rem 0 0;font-size:1.3rem;line-height:1.5;color:#555}',
      '.rocco-kaching-more__selection[hidden]{display:none!important}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function render(widget) {
    if (!widget.isConnected) return;
    widget.querySelectorAll('.rocco-kaching-more').forEach(function (control) {
      var owner = controlLists.get(control);
      if (!owner || !owner.isConnected || owner.closest('kaching-bundles-block') !== widget) control.remove();
    });
    widget.querySelectorAll('.kaching-bundles__bars').forEach(function (list) {
      if (list.closest('.kaching-bundles__subscriptions') || list.closest('kaching-bundles-block') !== widget) return;
      var bars = Array.from(list.children).filter(function (node) { return node.matches('.kaching-bundles__bar[data-deal-bar-id]'); });
      var state = lists.get(list);
      if (bars.length <= 3) {
        bars.forEach(function (bar) { bar.removeAttribute('data-rocco-bundle-overflow-hidden'); });
        if (state && state.control.isConnected) state.control.remove();
        return;
      }
      ensureStyles();
      if (!state) {
        var control = document.createElement('div');
        control.className = 'rocco-kaching-more';
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rocco-kaching-more__button';
        var text = document.createElement('span');
        button.appendChild(text);
        button.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m5 7.5 5 5 5-5"/></svg>');
        var selection = document.createElement('p');
        selection.className = 'rocco-kaching-more__selection';
        selection.hidden = true;
        control.appendChild(button);
        control.appendChild(selection);
        state = { expanded: false, control: control, button: button, text: text, selection: selection };
        lists.set(list, state);
        controlLists.set(control, list);
        button.addEventListener('click', function () {
          state.expanded = !state.expanded;
          render(widget);
        });
      }
      if (!list.id) list.id = 'RoccoKachingOptions-' + (++nextId);
      if (state.control.previousElementSibling !== list) list.insertAdjacentElement('afterend', state.control);
      var language = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
      var copy = labels[language] || labels.en;
      state.button.setAttribute('aria-controls', list.id);
      state.button.setAttribute('aria-expanded', String(state.expanded));
      var label = state.expanded ? copy.less : copy.more;
      if (state.text.textContent !== label) state.text.textContent = label;
      var hiddenSelection = '';
      bars.forEach(function (bar, index) {
        var hide = index >= 3 && !state.expanded;
        if (bar.hasAttribute('data-rocco-bundle-overflow-hidden') !== hide) bar.toggleAttribute('data-rocco-bundle-overflow-hidden', hide);
        if (hide && bar.classList.contains('kaching-bundles__bar--selected')) {
          var title = bar.querySelector('.kaching-bundles__bar-title');
          hiddenSelection = title ? title.textContent.trim() : '';
        }
      });
      // Collapsing never changes the purchase selection; keep it clear when hidden.
      var selectionText = hiddenSelection ? copy.selected + hiddenSelection : '';
      if (state.selection.textContent !== selectionText) state.selection.textContent = selectionText;
      if (state.selection.hidden !== !hiddenSelection) state.selection.hidden = !hiddenSelection;
    });
  }

  function schedule(widget) {
    if (!widget.closest('product-info') || widget.closest('kaching-bundles-sticky-atc')) return;
    var state = widgets.get(widget);
    if (!state) {
      state = { queued: false };
      widgets.set(widget, state);
      new MutationObserver(function () { schedule(widget); }).observe(widget, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    }
    if (state.queued) return;
    state.queued = true;
    requestAnimationFrame(function () { state.queued = false; render(widget); });
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('kaching-bundles-block')) schedule(root);
    root.querySelectorAll('kaching-bundles-block').forEach(schedule);
  }
  ['variants-changed', 'deal-bar-selected', 'kaching-bundles-block-hydrated'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.target.matches && event.target.matches('kaching-bundles-block')) schedule(event.target);
    }, true);
  });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  new MutationObserver(function (records) {
    records.forEach(function (record) { record.addedNodes.forEach(scan); });
  }).observe(document, { childList: true, subtree: true });
  scan(document);
})();
